export const StatusesMap = {
    ACCEPTED: 'accepted',
    PASSED: 'passed',
    NEED_CHECKING: 'need_checking',
    REJECTED: 'rejected',
    FAILED: 'failure',
    RESET: 'reset',
};

export const TaskTypes = {
    ESSAY: 'essay_version',
    FILES: 'files_version',
    ESSAY_WITH_FILES: 'essay_with_files_version',
    RESPONSE: 'response',
};

export const DEFAULT_HOMEWORK_FILTER_VALUE = {
    not_authorized: false,
    status: [],
    mentors: [],
    sort: 'timeOrder',
    sortDirection: 'asc',
};
